module.exports = __webpack_public_path__ + "img/Yemen.37cba4fb.svg";